import { CircularProgress } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTablePagination from "src/Component/customtablepagination/CustomTablePagination";
import { getCounsellorLogListAsync } from "src/redux/services/table";

export default function BasicTable() {
  const dispatch = useDispatch();

  const { getCounsellorLogList, isLoading, totalCount } = useSelector(
    (store) => store.counsellorList,
  );

  // Default query
  const [query, setQuery] = React.useState({
    page: 1,
    limit: 10,
  });

  // Page change
  const handlePageChange = (event, newPage) => {
    setQuery((prev) => ({
      ...prev,
      page: newPage + 1,
    }));
  };

  // API call with query
  useEffect(() => {
    dispatch(getCounsellorLogListAsync(query));
  }, [dispatch, query]);

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: "#00999E", color: "#fff" }}>
                S.no.
              </TableCell>

              <TableCell
                align="center"
                sx={{ backgroundColor: "#00999E", color: "#fff" }}
              >
                Student Name
              </TableCell>

              <TableCell
                align="center"
                sx={{ backgroundColor: "#00999E", color: "#fff" }}
              >
                Counsellor Name
              </TableCell>

              <TableCell
                align="center"
                sx={{ backgroundColor: "#00999E", color: "#fff" }}
              >
                Assign Date
              </TableCell>

              <TableCell
                align="center"
                sx={{ backgroundColor: "#00999E", color: "#fff" }}
              >
                Created By
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress size={24} sx={{ color: "#00999E" }} />
                </TableCell>
              </TableRow>
            ) : getCounsellorLogList?.length > 0 ? (
              getCounsellorLogList.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {(query.page - 1) * query.limit + index + 1}
                  </TableCell>

                  <TableCell align="center">{row.studentName}</TableCell>

                  <TableCell align="center">{row.counsellorName}</TableCell>

                  <TableCell align="center">
                    {dayjs(row.assignedDate).format("DD/MM/YYYY hh:mm a")}
                  </TableCell>

                  <TableCell align="center">{row.createdBy}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <CustomTablePagination
          count={totalCount || 0}
          page={query.page - 1}
          rowsPerPage={query.limit}
          onPageChange={handlePageChange}
          rowsPerPageOptions={[]}
        />
      </TableContainer>
    </>
  );
}
